import { inject, Pipe, PipeTransform, ViewContainerRef } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import * as echarts from 'echarts';
import { LoadCurveSummaryEntry } from '../../../core/clients/omni-core/models';
import { getLinePlaceholderConfig } from '../chart-config/consumption/line-placeholder.chart-config';
import {
  ConsumptionGraphConfigOptions,
  getColors,
  toChartData,
} from '../chart-config/consumption/util';
import { getLineConfig } from '../chart-config/consumption/line.chart-config';
import { getBarConfig } from '../chart-config/consumption/bar.chart-config';
import { getBarPlaceholderConfig } from '../chart-config/consumption/bar-placeholder.chart-config';

@Pipe({
  name: 'analysisConsumptionChartOptions',
})
export class AnalysisConsumptionChartOptionsPipe implements PipeTransform {
  private translocoService = inject(TranslocoService);
  private vcr = inject(ViewContainerRef);

  transform(
    inputData: LoadCurveSummaryEntry[],
    options: ConsumptionGraphConfigOptions,
  ): echarts.EChartsOption {
    const data = toChartData(inputData);

    const colors = getColors(options.utilityType);

    switch (options.view) {
      case 'line':
        if (options.placeholder) {
          return getLinePlaceholderConfig(
            { translocoService: this.translocoService },
            {
              colors: colors,
              granularity: options.granularity,
            },
          );
        }
        return getLineConfig({ translocoService: this.translocoService, vcr: this.vcr }, data, {
          colors: colors,
          granularity: options.granularity,
        });
      case 'bar':
        if (options.placeholder) {
          return getBarPlaceholderConfig(
            { translocoService: this.translocoService },
            {
              colors: {
                border: colors.line,
                background: colors.areaStop1,
              },
              granularity: options.granularity,
            },
          );
        }
        return getBarConfig({ translocoService: this.translocoService, vcr: this.vcr }, data, {
          color: colors.line,
          granularity: options.granularity,
        });
      case 'table':
        throw new Error('invalid graph type "table"');
    }
  }
}
